export const getMessageFromActions = (response) => {
    const { data } = response?.response || response || {};

    return data?.actions?.PlayerActionShowMessage?.[0]?.message;
};
